import React from "react";
import { LongTextLabel, Tooltip } from "@sscs/ui";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { sourceFiltered } from "../../../../store/filesDiffSlice";
import DeletedFileIcon from "../../../assets/images/icons/deleted-file.svg";
import FileIcon from "../../../assets/images/icons/file.svg";
import { LinkToReportTab } from "../../../common";
import { useFinalCheckLabel, useReportDispatch } from "../../../hooks";
import styles from "./fileName.module.scss";
const FileName = ({ index, file }) => {
    const dispatch = useReportDispatch();
    const { isRepro } = useFinalCheckLabel();
    return (React.createElement("div", { className: styles["file-name"] },
        file.deleted ? (React.createElement(Tooltip, { trigger: "graphic", placement: "bottom", title: "File was removed from the package" },
            React.createElement("div", { className: styles["deleted-file-icon"] },
                React.createElement(DeletedFileIcon, null)))) : (React.createElement(Tooltip, { trigger: "graphic", placement: "bottom", title: "File present in the package" },
            React.createElement("div", { className: styles["file-icon"] },
                React.createElement(FileIcon, null)))),
        React.createElement(LinkToReportTab, { underline: "hover", id: `dif-${file.id}-file-${index}`, to: isRepro
                ? `${REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE}/${REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES}`
                : `${REPORT_PAGES_ROUTES.VERSION_DIFF}/${REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES}`, onClick: () => dispatch(sourceFiltered({
                name: file.name,
                id: file.id,
            })), color: "link" },
            React.createElement(LongTextLabel, { label: file.name }))));
};
export default FileName;
//# sourceMappingURL=FileName.js.map